export default {
  isLoading: false,
  accountGroups: [],
  businessError: null,
  openedAccount: {},
};
